import React from "react";
import "./styles/tailwind.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { MsalProvider } from "@azure/msal-react";
import { ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { msalInstance } from "./auth/msalInstance";
import { ContactNotesProvider } from "./providers/ContactNotesProvider";
import reportWebVitals from "./reportWebVitals";
import { bootstrapPwa } from "./services/pwa";
import "@fontsource/montserrat";
import "@fontsource/lato";
import "@fontsource/open-sans";
import "@fontsource/poppins";
import { theme } from "./styles/theme";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ThemeProvider theme={theme}>
          <MsalProvider instance={msalInstance}>
            <ContactNotesProvider>
              <App />
            </ContactNotesProvider>
          </MsalProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}

bootstrapPwa();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
